import Alert from './Alert';
import uploadHandler from './uploadHandler';
import router from './router';
import toggleCheckBoxes from './toggleCheckBoxes';
import confirm from './confirmation/confirm';
import urlParser from './urlParser';
import colorParser from './colorParser';
import {
  searchCompany,
  searchUser,
  searchCustomer,
  searchIntegrations
} from './searchers';

export const renderFullName = data => {
  if (data.firstName || data.lastName) {
    return (data.firstName || '') + ' ' + (data.lastName || '');
  }
  return data.email || data.phone || 'N/A';
};

export const setTitle = (title, force) => {
  if (!document.title.includes(title) || force) {
    document.title = title;
  }
};

export const setBadge = (count, title) => {
  const favicon = document.getElementById('favicon');

  if (count) {
    if (document.title.includes(title)) {
      setTitle(`(${count}) ${title}`);
    }

    return (favicon.href = '/favicon-unread.png');
  }

  favicon.href = '/images/TLight.png';
};

export const reorder = (list, startIndex, endIndex) => {
  const result = Array.from(list);

  const [removed] = result.splice(startIndex, 1);
  result.splice(endIndex, 0, removed);

  return result;
};

export const generateRandomColorCode = () => {
  return `#${Math.random()
    .toString(16)
    .slice(2, 8)}`;
};

// Create an array with "stop" numbers, starting from "start"
export const range = (start, stop) => {
  return Array.from(Array(stop), (_, i) => start + i);
};

// Return the list of values that are the intersection of two arrays
export const intersection = (array1, array2) => {
  return array1.filter(n => array2.includes(n));
};

// Computes the union of the passed-in arrays: the list of unique items
export const union = (array1, array2) => {
  return array1.concat(array2.filter(n => !array1.includes(n)));
};

// Similar to without, but returns the values from array that are not present in the other arrays.
export const difference = (array1, array2) => {
  return array1.filter(n => !array2.includes(n));
};

export const removeSpecific = function(arr) {
  var what,
    a = arguments,
    L = a.length,
    ax;
  while (L > 1 && arr.length) {
    what = a[--L];
    while ((ax = arr.indexOf(what)) !== -1) {
      arr.splice(ax, 1);
    }
  }
  return arr;
};

export const arrayToObject = (arr = []) => {
  let result = {};
  arr.forEach(el => {
    if (el.key && el.value) {
      result[el.key] = el.value;
    }
  });
  return result;
};
export const objectToArray = obj => {
  let result = [];
  for (const prop in obj) {
    if (prop && obj[prop]) {
      result.push({ key: prop, value: obj[prop] });
    }
  }
  return result;
};
export {
  Alert,
  uploadHandler,
  router,
  confirm,
  toggleCheckBoxes,
  urlParser,
  colorParser,
  searchCompany,
  searchUser,
  searchIntegrations,
  searchCustomer
};



// WEBPACK FOOTER //
// ./src/modules/theme/theme1/common/utils/index.js